function openRegPopup() {
  document.getElementById("registrationPopup").style.display = "flex";
  document.body.classList.add("popup-open");
}

function closeRegPopup() {
  // Close popup
  document.getElementById("registrationPopup").style.display = "none";
  document.body.classList.remove("popup-open");

  // ✅ Close mobile hamburger menu (Shopify default themes)
  const menuToggle = document.querySelector('button[aria-controls]');
  if (menuToggle && menuToggle.getAttribute('aria-expanded') === 'true') {
    menuToggle.click();
  }

  // ✅ Fallback for drawer-based menus
  const drawer = document.querySelector('.menu-drawer, .mobile-nav, .drawer');
  if (drawer) {
    drawer.classList.remove('active', 'open');
  }
}


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('a[href="#"]').forEach(link => {
    if (link.textContent.trim().toLowerCase() === "register") {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        openRegPopup();
      });
    }
  });
});
